import axios from "axios";
import { Loading } from "element-ui";

const http = axios.create({
  timeout: 30000, // 请求超时时间
});

/* 线上环境 */
const uploadUrl = "https://testapi.xinian727.cn";
const imgUrl = "https://testapi.xinian727.cn/api/product/common/uploadQunce";
const prefix = "https://testapi.xinian727.cn"; //新群策
// const prefix = "http://192.168.16.108"; //新群策
// const prefix = 'https://qc.xinian727.com'//老群策

/* 测试环境 */
// const uploadUrl = 'https://testapi.xinian727.com';
// const prefix = 'https://testapi.xinian727.cn';
// const imgUrl = 'https://testapi.xinian727.cn/api/product/common/uploadQunce';

/* 本地 */
// const prefix = "http://192.168.16.114"; //布

/**
 * 请求拦截器
 */
http.interceptors.request.use(
  function(config) {
    showLoaing();
    if (config.url !== "/login") {
      config.headers.token = window.localStorage.getItem("token");
    }
    if (config.url == "/api/product/product/product") {
      config.url = "https://testapi.xinian727.cn" + config.url;
    } else if (config.url.indexOf("qcn.") != -1) {
      config.url = config.url;
    } else if (config.url.indexOf("source") != -1) {
      config.url = "https://qc.xinian727.com" + config.url;
    } else {
      config.url = prefix + config.url;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function(response) {
    hideLoading();
    return response;
  },
  function(error) {
    hideLoading();
    return Promise.reject(error);
  }
);

export default {
  http,
  prefix,
  uploadUrl,
  imgUrl,
};

// 请求两个接口，一个接口请求回来之后，立马关闭loading ,导致第二个请求还没有回来，已经关闭loading了，体验不好。
// 判断有多少个请求，等所有的请求回来之后再关闭

let loading; //loading的实例对象
let loadingCount = 0;

function start() {
  loading = Loading.service({
    lock: true,
    text: "加载中",
    background: "rgba(0,0,0,0.1)",
  });
}

function end() {
  loading.close();
}

function showLoaing() {
  if (loadingCount == 0) {
    start();
  }
  loadingCount++;
}

function hideLoading() {
  loadingCount--;
  if (loadingCount == 0) {
    end();
  }
}
